import React, { Component } from 'react';
import { Input, Form, FormGroup, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { updateStoreConfig } from '../../store/editStoreActions';
import { bindActionCreators } from 'redux';
import { IconLink } from '../Icons/Icons';
import './StoreConfig.css';

class StoreConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      config: {}
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.store) {
      return {
        config: nextProps.store
      };
    }
    return null;
  }

  handleChange(e, id) {
    let { value } = e.target;
    let inputId = id;
    if (!inputId) {
      inputId = e.target.id;
    }
    const config = {
      ...this.state.config,
      [inputId]: value
    };
    this.props.updateStoreConfig(this.props.storeId, config);
  }

  render() {
    const { config } = this.state;

    if (!config) {
      return null;
    }

    return (
      <div className="store-config">
        <Form className="flex-form">
          <FormGroup className="flex-50">
            <Label>Store ID</Label>
            <Input id="id" value={this.props.storeId || ''} readOnly />
            <small className="text-muted">
              Reference this ID within the CMS article as follows:{' '}
            </small>

            <pre className="mb-0">
              <code className="text-success">
                &lt;div id="store-root" data-store-id="
                {this.props.storeId}" data-store-env="
                {this.props.environment}"&gt;&lt;/div&gt;
              </code>
            </pre>
          </FormGroup>
          <FormGroup className="flex-25">
            <Label>Image base path</Label>
            <Input
              id="imageBasePath"
              onChange={e => this.handleChange(e)}
              value={config.imageBasePath || ''}
            />
          </FormGroup>
          <FormGroup className="flex-25">
            <Label>Theme</Label>
            <Input
              title="Choose store theme"
              type="select"
              id="theme"
              onChange={e => this.handleChange(e)}
              value={config.theme || ''}
            >
              <option value="" defaultValue>
                Default
              </option>
              <option value="dark">Dark</option>
              <option value="light">Light</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>
              Production URL{' '}
              <a
                href={config.productionUrl}
                target="_blank"
                title="Visit Production version of store"
              >
                <IconLink />
              </a>
            </Label>
            <Input
              id="productionUrl"
              onChange={e => this.handleChange(e)}
              value={config.productionUrl || ''}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              Test URL
              <a
                href={config.testUrl}
                target="_blank"
                title="Visit Test version of store"
              >
                <IconLink />
              </a>
            </Label>
            <Input
              id="testUrl"
              onChange={e => this.handleChange(e)}
              value={config.testUrl || ''}
            />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = ({ activeStore }) => ({
  store: activeStore.activeStore ? activeStore[activeStore.activeStore] : null,
  storeId: activeStore.activeStore
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateStoreConfig: (storeId, config) => updateStoreConfig(storeId, config)
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreConfig);



// WEBPACK FOOTER //
// ./src/components/StoreConfig/StoreConfig.js